import { Skeleton, Stack, Typography } from '@mui/joy';
import { isNumber } from 'lodash';
import { useTranslation } from 'react-i18next';

import { getAbbreviatedNumber } from 'core/utils/number';
import { Direction, Level, SkeletonVariant } from 'theme/enums';

interface IMetric {
  color?: string;
  labelKey: string;
  value: number | string;
}

interface IProps {
  metrics: IMetric[];
  isLoading?: boolean;
}

export const SummaryMetric = ({ metrics, isLoading }: IProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Stack direction={Direction.ROW} sx={{ flex: 1, gap: 3 }}>
        {metrics.map((_, metricIndex) => (
          <Stack key={metricIndex} sx={{ flex: 1, gap: 0.5 }}>
            <Skeleton variant={SkeletonVariant.TEXT} width="60%" height={20} />
            <Skeleton variant={SkeletonVariant.TEXT} width="80%" height={32} />
          </Stack>
        ))}
      </Stack>
    );
  }

  return (
    <Stack direction={Direction.ROW} sx={{ flex: 1, gap: 3 }}>
      {metrics.map((metric, metricIndex) => (
        <Stack key={metricIndex} sx={{ flex: 1, gap: 0.5 }}>
          <Typography level={Level.BODY_SM}>{t(metric.labelKey)}</Typography>
          <Typography
            level={Level.H3}
            sx={{
              color: metric.color,
              fontWeight: 'bold',
            }}
          >
            {isNumber(metric.value) ? getAbbreviatedNumber(metric.value) : metric.value}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
